import * as React from 'react';
import { ReactComponent as ToothIconSVG } from '../../assets/icons/mevo/ic_tooth_primary.svg';
import IconPattern, { IconProps } from './_IconPattern';

const ToothIconPrimary: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={ToothIconSVG} variantPlaces={2} {...props} />;
};

export default ToothIconPrimary;
